export const INCLUSION_LEVELS = {
  ALL_INCLUDED: 'all_included',
  PARTIAL: 'partial',
  WIFI_ONLY: 'wifi_only',
  UNKNOWN: 'unknown',
}

/**
 * Clasifica el nivel de servicios incluidos de un coliving.
 * - all_included: WiFi + limpieza + agua/residuos + electricidad + comunidad
 * - partial: WiFi + algún servicio extra, pero no todo incluido
 * - wifi_only: solo WiFi
 */
export function getColivingInclusionLevel(listing) {
  if (!listing) return INCLUSION_LEVELS.UNKNOWN

  const hasWifi = !!listing.servicesInternet
  const hasCleaning = !!listing.servicesCleaning
  const hasWater = !!listing.servicesWaterAndWaste
  const hasElectricity = !!listing.servicesElectricity
  const hasCommunity = !!listing.servicesCommunityFees

  if (hasWifi && hasCleaning && hasWater && hasElectricity && hasCommunity) {
    return INCLUSION_LEVELS.ALL_INCLUDED
  }

  if (hasWifi && (hasCleaning || hasWater || hasElectricity || hasCommunity)) {
    return INCLUSION_LEVELS.PARTIAL
  }

  if (hasWifi) return INCLUSION_LEVELS.WIFI_ONLY

  return INCLUSION_LEVELS.UNKNOWN
}

export function getInclusionBadgeClass(level) {
  switch (level) {
    case INCLUSION_LEVELS.ALL_INCLUDED:
      return 'text-emerald-600'
    case INCLUSION_LEVELS.PARTIAL:
      return 'text-amber-600'
    case INCLUSION_LEVELS.WIFI_ONLY:
      return 'text-gray-500'
    default:
      return ''
  }
}

/**
 * Badge de inclusión para cards/mapa. Solo se muestra "Todo incluido";
 * parcial, solo WiFi y desconocido → sin leyenda.
 */
export function buildInclusionBadge(listing, labels) {
  const level = getColivingInclusionLevel(listing)
  if (level !== INCLUSION_LEVELS.ALL_INCLUDED) return null
  return {
    text: labels.allIncluded,
    class: getInclusionBadgeClass(level),
  }
}
